import { render } from "./tasks.vue?vue&type=template&id=5ace4150&lang=pug"
import script from "./tasks.vue?vue&type=script&setup=true&lang=js"
export * from "./tasks.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__